module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjAQMAAAC19SzWAAAABlBMVEXYHgX///+zuthOAAAAGUlEQVQ4y2MYBcMJ/EcCD0Z5Q5w3CoYRAABW7qdk3czLewAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/austria.png
// module id = 618
// module chunks = 0